/*
 * Copyright © 2017 TEKTELIC Communications Inc.
 */

export default angular.module('tektelic.api.firmware', [])
    .factory('firmwareService', FirmwareService)
    .name;

/*@ngInject*/
function FirmwareService($http, $q) {

    var service = {
        getFirmwareDesired: getFirmwareDesired,
        getFirmwareReported: getFirmwareReported,
        saveFirmwareDesired: saveFirmwareDesired,
        deleteFirmwareDesired: deleteFirmwareDesired
    }

    return service;

    function getFirmwareDesired(entityType, entityId) {
        var deferred = $q.defer();
        $http.get(`/api/firmware/desired/${entityType}/${entityId}`, null).then(function success(response) {
            deferred.resolve(response.data);
        }, function fail() {
            deferred.reject();
        });
        return deferred.promise;
    }

    function getFirmwareReported(entityId) {
        var deferred = $q.defer();
        $http.get(`/api/firmware/reported/GATEWAY/${entityId}`, {ignoreErrors: true}).then(function success(response) {
            deferred.resolve(response.data);
        }, function fail() {
            deferred.reject();
        });
        return deferred.promise;
    }

    function saveFirmwareDesired(entityType, entityId, firmware) {
        var deferred = $q.defer();
        var url = `/api/firmware/desired/${entityType}/${entityId}`;
        $http.put(url, firmware).then(function success(response) {
            deferred.resolve(response.data);
        }, function fail() {
            deferred.reject();
        });
        return deferred.promise;
    }

    function deleteFirmwareDesired(entityType, entityId) {
        var deferred = $q.defer();
        var url = `/api/firmware/desired/${entityType}/${entityId}`;
        $http.delete(url).then(function success() {
            deferred.resolve();
        }, function fail() {
            deferred.reject();
        });
        return deferred.promise;
    }

}



// WEBPACK FOOTER //
// ./src/app/api/firmware.service.js